import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

Swiper.use([Navigation, Pagination])

const SELECTOR = '[data-swiper]'

export default class RemoteSwiper {
  constructor() {
    this.handleContentLoaded = this.handleContentLoaded.bind(this)
  }

  init() {
    document.addEventListener('remote-modal:content-loaded', this.handleContentLoaded)
  }

  handleContentLoaded(event) {
    if (!(event.target instanceof Element)) {
      return
    }

    this.enhance(event.target)
  }

  enhance(root) {
    root.querySelectorAll(SELECTOR).forEach((element) => {
      if (!(element instanceof HTMLElement)) {
        return
      }

      if (element.swiper) {
        return
      }

      let options

      if (element.dataset.swiper) {
        options = JSON.parse(element.dataset.swiper)
      }

      new Swiper(element, options)
    })
  }
}
